import styled from 'styled-components';

const ButtonInline = styled.button.attrs({
  type: 'button',
})`
  display: inline;
  padding: 0;
  border: none;
  background: none;
  color: ${({ theme }) => theme.color.link};
  font-size: inherit;
  font-weight: inherit;
  cursor: pointer;

  &:hover {
    opacity: ${({ theme }) => theme.button.opacity.hover};
  }

  &:disabled,
  &:disabled:hover,
  &:disabled:active {
    color: ${({ theme }) => theme.button.borderColor.disabled};
  }
`;

export default ButtonInline;
